import { messages } from './messages';

export const NumberOfLineItems = {
  messageDescriptor: messages.numberOfLineItems,
  id: 'num-line-items',
};
